<div class="row mt-5 justify-content-end mb-4">
  <div class="col-md-6">
      <div class="row mt-2">
          <div class="col-md-2">Uk. duguje:</div>
          <div class="col-md-3 text-right font-weight-bold border">{{ukupnoDuguje}}</div>
          <div class="col-md-2">Uk. potražuje:</div>
          <div class="col-md-3 text-right font-weight-bold border">{{ukupnoPotrazuje}}</div>
        </div>
      <!-- <div class="row mt-2">
          <div class="col-md-7">Uk. potražuje:</div>
          <div class="col-md-4 text-right font-weight-bold border">{{ukupnoPotrazuje}}</div>
      </div> -->
      <div class="row mt-2">
        <div class="col-md-2">Uk. dev. duguje:</div>
        <div class="col-md-3 text-right font-weight-bold border">{{ukupnoDDuguje}}</div>
        <div class="col-md-2">Uk. dev. potražuje:</div>
        <div class="col-md-3 text-right font-weight-bold border">{{ukupnoDPotrazuje}}</div>
    </div>
    <!-- <div class="row mt-2">
        <div class="col-md-7">Uk. dev. potražuje:</div>
        <div class="col-md-4 text-right font-weight-bold border">{{ukupnoDPotrazuje}}</div>
    </div> -->
  </div>
</div>